import LinkifyIt from 'linkify-it'

const linkify = new LinkifyIt()

export type TextSegment =
    | { type: 'text'; value: string }
    | { type: 'link'; url: string; label: string }

export const splitTextWithLinks = (text: string): TextSegment[] => {
    const matches = linkify.test(text) ? (linkify.match(text) ?? []) : []

    if (matches.length === 0) {
        return [{ type: 'text', value: text }]
    }

    const segments: TextSegment[] = []
    let lastIndex = 0

    matches.forEach(match => {
        if (match.index > lastIndex) {
            segments.push({ type: 'text', value: text.slice(lastIndex, match.index) })
        }
        segments.push({ type: 'link', url: match.url, label: match.text })
        lastIndex = match.lastIndex
    })

    if (lastIndex < text.length) {
        segments.push({ type: 'text', value: text.slice(lastIndex) })
    }

    return segments
}
